import React, { Component } from "react"
import { Redirect } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
	faSync,
	faChevronDown,
	faTruckPickup,
	faCar,
	faTrash,
} from "@fortawesome/free-solid-svg-icons"
import { connect } from "react-redux"
import {
	fetchEmployes,
	fetchAppels,
} from "../../store/actions/depannageActions"
import {
	fetchAtelierSearch,
	atelierSearchToggleHideresult,
	deleteAtelierReset,
	deleteAtelier,
} from "../../store/actions/atelierSearchActions"
import AtelierSearchTotal from "./AtelierSearchTotal"
import moment from "moment"
import * as Addons from "../../utilities/Addons"
import { atelierTable } from "../PDF/AtelierTable"
import DeleteModal from "../others/DeleteModal"
import AtelierSearchMarge from "./AtelierSearchMarge"
import {
	ATELIER_ETATS_CHOICES,
	formatNumber,
	HTtoTTC,
	onEnter,
	round100,
} from "../../utilities/Addons"

class AtelierSearch extends Component {
	constructor(props) {
		super(props)
		this.state = {
			clicked: false,
			hideResult: true,
			working: false,
			selectedRow: null,
			redirect: false,
			openTotal: false,
			openMarge: false,
			sortByDate: true,
			sortByNom: false,
			sortByEtat: false,
			sortByEmploye: false,
			sortByTotal: false,
			redirectDep: false,
			redirectDepId: 0,
			redirectLocation: false,
			redirectLocationId: 0,

			modalDelete: false,
			modalDeleteId: 0,
			modalDeleteTitle: "",

			isSVP: false,
			boss: false,
		}
		this.initRefs()
	}

	componentDidMount = () => {
		this.props.dispatch(fetchEmployes())
		this.props.dispatch(fetchAppels())
		if (this.props.atelierSearchInfo.atelierFiches.length > 0) {
			this.setState({
				isSVP: this.props.atelierSearchInfo.atelierFiches[0].svp,
			})
		}
		document.addEventListener("keydown", this.listener)
		document.addEventListener("keydown", this.escListener)
		document.addEventListener("keydown", this.resetListener)
	}

	componentWillUnmount = () => {
		document.removeEventListener("keydown", this.listener)
		document.removeEventListener("keydown", this.escListener)
		document.removeEventListener("keydown", this.resetListener)
	}

	resetListener = (e) => {
		if (e.key === "F9") {
			e.preventDefault()
			this.reset()
		}
	}

	openModalDelete = (id, title) => {
		this.setState({
			modalDelete: true,
			modalDeleteId: id,
			modalDeleteTitle: title,
		})
	}
	closeModalDelete = () => {
		this.setState({
			modalDelete: false,
			modalDeleteId: 0,
			modalDeleteTitle: "",
		})
		this.props.dispatch(deleteAtelierReset())
	}
	deleteAtelier = () => {
		const {
			sortByEtat,
			sortByTotal,
			sortByEmploye,
			sortByNom,
			sortByDate,
		} = this.state
		this.props.dispatch(
			deleteAtelier(
				JSON.stringify({
					id: this.state.modalDeleteId,
					search: {
						nom: this.refNom.current.value,
						plaques: this.refPlaques.current.value,
						marque: this.refMarque.current.value,
						employe: this.refDepanneur.current.value,
						etat: this.refEtat.current.value,
						dateT: this.refDateT.current.value,
						dateS: this.refDateS.current.value,
						dateE: this.refDateE.current.value,
						boss: this.refBoss.current.checked,
						svp: this.refSVP.current.checked,
					},
					orderBy: sortByTotal
						? "total"
						: sortByEmploye
							? "employe"
							: sortByNom
								? "nom"
								: sortByEtat
									? "etat"
									: sortByDate
										? "date"
										: "",
				}),
			),
		)
	}

	initRefs = () => {
		this.refNom = React.createRef()
		this.refMarque = React.createRef()
		this.refPlaques = React.createRef()
		this.refDepanneur = React.createRef()
		this.refEtat = React.createRef()
		this.refDateT = React.createRef()
		this.refDateS = React.createRef()
		this.refDateE = React.createRef()
		this.refBoss = React.createRef()
		this.refSVP = React.createRef()
	}

	listener = (e) => {
		switch (e.key) {
			case "F9":
				e.preventDefault()
				if (this.props.atelierSearchInfo.hideResult) this.reset()
				break
			case "F10":
				e.preventDefault()
				if (
					this.props.navInfo.login.groups.includes("boss") &&
					!this.props.atelierSearchInfo.hideResult
				)
					this.state.openTotal ? this.closeTotal() : this.openTotal()
				break
			case "F11":
				e.preventDefault()
				if (!this.props.atelierSearchInfo.hideResult)
					atelierTable(this.props.atelierSearchInfo.atelierFiches)
				break
			default:
				break
		}
		if (e.keyCode === 121) {
			e.preventDefault()
		}
	}

	openTotal = () => {
		this.setState({ openTotal: true })
	}

	closeTotal = () => {
		this.setState({ openTotal: false })
	}

	openMarge = () => {
		this.setState({ openMarge: true })
	}

	closeMarge = () => {
		this.setState({ openMarge: false })
	}

	hideSearch = () => {
		this.props.dispatch(atelierSearchToggleHideresult())
	}

	search = () => {
		let formData = new FormData(document.getElementById("form-search"))
		let json = {}
		for (let [key, value] of formData.entries()) json[key] = value
		json["svp"] = this.state.isSVP
		json["boss"] = this.state.boss
		this.setState({
			sortByDate: true,
			sortByNom: false,
			sortByEtat: false,
			sortByEmploye: false,
			sortByTotal: false,
		})
		this.props.dispatch(fetchAtelierSearch(json))
	}

	clickRow = (row) => {
		if (row === this.state.selectedRow) this.setState({ selectedRow: null })
		else this.setState({ selectedRow: row })
	}

	doubleClickRow = (id) => {
		this.setState({ redirect: true, id })
	}

	reset = () => {
		this.refNom.current.value = ""
		this.refMarque.current.value = ""
		this.refPlaques.current.value = ""
		this.refDepanneur.current.value = 0
		this.refEtat.current.value = -2
		this.refDateT.current.value = 0
		this.refDateS.current.value = ""
		this.refDateE.current.value = ""
		this.refSVP.current.checked = false
		this.setState({ isSVP: false, boss: false })
	}

	sortByDate = () => {
		this.props.atelierSearchInfo.atelierFiches.sort((a, b) => {
			let sortByDate = !this.state.sortByDate
			this.setState({
				sortByDate,
				sortByNom: false,
				sortByEmploye: false,
				sortByEtat: false,
				sortByTotal: false,
			})
			let aDate = moment(a.date, "DD-MM-YYYY")
			let bDate = moment(b.date, "DD-MM-YYYY")
			if (sortByDate) {
				if (aDate < bDate) return -1
				else if (aDate > bDate) return 1
				else return 0
			} else {
				if (aDate < bDate) return 1
				else if (aDate > bDate) return -1
				else return 0
			}
		})
	}

	sortByNom = () => {
		this.props.atelierSearchInfo.atelierFiches.sort((a, b) => {
			let sortByNom = !this.state.sortByNom
			this.setState({
				sortByDate: false,
				sortByNom,
				sortByEmploye: false,
				sortByEtat: false,
				sortByTotal: false,
			})
			if (sortByNom) {
				if (a.nom < b.nom) return -1
				else if (b.nom < a.nom) return 1
				else {
					if (
						moment(a.date, "DD-MM-YYYY") <
						moment(b.date, "DD-MM-YYYY")
					)
						return -1
					else if (
						moment(a.date, "DD-MM-YYYY") >
						moment(b.date, "DD-MM-YYYY")
					)
						return 1
					else return 0
				}
			} else {
				if (a.nom < b.nom) return 1
				else if (b.nom < a.nom) return -1
				else {
					if (
						moment(a.date, "DD-MM-YYYY") <
						moment(b.date, "DD-MM-YYYY")
					)
						return -1
					else if (
						moment(a.date, "DD-MM-YYYY") >
						moment(b.date, "DD-MM-YYYY")
					)
						return 1
					else return 0
				}
			}
		})
	}

	sortByEtat = () => {
		this.props.atelierSearchInfo.atelierFiches.sort((a, b) => {
			let sortByEtat = !this.state.sortByEtat
			this.setState({
				sortByDate: false,
				sortByEtat,
				sortByEmploye: false,
				sortByNom: false,
				sortByTotal: false,
			})
			if (sortByEtat) {
				if (a.etat < b.etat) return -1
				else if (b.etat < a.etat) return 1
				else {
					if (
						moment(a.date, "DD-MM-YYYY") <
						moment(b.date, "DD-MM-YYYY")
					)
						return -1
					else if (
						moment(a.date, "DD-MM-YYYY") >
						moment(b.date, "DD-MM-YYYY")
					)
						return 1
					else return 0
				}
			} else {
				if (a.etat < b.etat) return 1
				else if (b.etat < a.etat) return -1
				else {
					if (
						moment(a.date, "DD-MM-YYYY") <
						moment(b.date, "DD-MM-YYYY")
					)
						return -1
					else if (
						moment(a.date, "DD-MM-YYYY") >
						moment(b.date, "DD-MM-YYYY")
					)
						return 1
					else return 0
				}
			}
		})
	}

	sortByEmploye = () => {
		this.props.atelierSearchInfo.atelierFiches.sort((a, b) => {
			let sortByEmploye = !this.state.sortByEmploye
			this.setState({
				sortByDate: false,
				sortByEmploye,
				sortByEtat: false,
				sortByNom: false,
				sortByTotal: false,
			})
			if (sortByEmploye) {
				if (a.employe < b.employe) return -1
				else if (b.employe < a.employe) return 1
				else {
					if (
						moment(a.date, "DD-MM-YYYY") <
						moment(b.date, "DD-MM-YYYY")
					)
						return -1
					else if (
						moment(a.date, "DD-MM-YYYY") >
						moment(b.date, "DD-MM-YYYY")
					)
						return 1
					else return 0
				}
			} else {
				if (a.employe < b.employe) return 1
				else if (b.employe < a.employe) return -1
				else {
					if (
						moment(a.date, "DD-MM-YYYY") <
						moment(b.date, "DD-MM-YYYY")
					)
						return -1
					else if (
						moment(a.date, "DD-MM-YYYY") >
						moment(b.date, "DD-MM-YYYY")
					)
						return 1
					else return 0
				}
			}
		})
	}

	sortByTotal = () => {
		this.props.atelierSearchInfo.atelierFiches.sort((a, b) => {
			let sortByTotal = !this.state.sortByTotal
			this.setState({
				sortByDate: false,
				sortByTotal,
				sortByEtat: false,
				sortByNom: false,
				sortByEmploye: false,
			})
			if (sortByTotal) {
				if (a.total < b.total) return -1
				else if (b.total < a.total) return 1
				else return 0
			} else {
				if (a.total < b.total) return 1
				else if (b.total < a.total) return -1
				else return 0
			}
		})
	}

	escListener = (e) => {
		if (e.key === "Escape") this.setState({ redirectMenu: true })
	}

	getTotal = (_atelier) => {
		const { isSVP } = this.state
		if (isSVP) {
			return round100(HTtoTTC(_atelier.total_achat_ht, _atelier.tva))
		}
		return round100(HTtoTTC(_atelier.total_ht, _atelier.tva))
	}

	render() {
		const { employes, fetchEmployes, atelierSearchInfo } = this.props
		const { deleteAtelier } = atelierSearchInfo
		const {
			id,
			redirect,
			redirectDepId,
			redirectDep,
			redirectLocation,
			redirectLocationId,
			redirectMenu,
		} = this.state
		const { modalDelete } = this.state
		if (redirect) {
			return (
				<Redirect
					to={{
						// La fiche legacy est supprimée (29.07.2026) : cette
						// recherche legacy ouvre désormais la fiche V2.
						pathname: `/atelier/fiche/${id}`,
						id,
						from: "atelierSearch",
					}}
				/>
			)
		}
		if (redirectDep) {
			return (
				<Redirect
					to={{
						pathname: `/depannage/fiche/${redirectDepId}`,
						id: redirectDepId,
						from: "atelierSearch",
					}}
				/>
			)
		}
		if (redirectLocation) {
			return (
				<Redirect
					to={{
						pathname: "/location/fiche:id",
						id: redirectLocationId,
						from: "atelierSearch",
					}}
				/>
			)
		}
		if (redirectMenu) {
			return <Redirect to={{ pathname: "/" }} />
		}
		return (
			<>
				{this.state.openTotal ? (
					<AtelierSearchTotal
						visible={this.state.openTotal}
						closeModal={this.closeTotal}
						employes={employes}
						ateliers={this.props.atelierSearchInfo.atelierFiches}
					/>
				) : null}
				{this.state.openMarge ? (
					<AtelierSearchMarge
						visible={this.state.openMarge}
						closeModal={this.closeMarge}
						ateliers={this.props.atelierSearchInfo.atelierFiches}
						token={this.props.navInfo.login.token}
					/>
				) : null}
				{modalDelete ? (
					<DeleteModal
						visible={modalDelete}
						closeModal={this.closeModalDelete}
						post={deleteAtelier}
						func={this.deleteAtelier}
						title={this.state.modalDeleteTitle}
					/>
				) : null}
				<div className="col flex-center rel">
					<h2 className="title2 full">Rechercher fiche atelier</h2>
					<form
						id="form-search"
						className={`form-container row eighty flex-center anim-hide ${atelierSearchInfo.hideResult ? "" : " hidden"}`}
						method="post"
						action=""
					>
						<div className="form-small form-dep form-client col flex-center">
							<div className="lab-in full">
								<label htmlFor="nom">Nom</label>
								<input
									type="text"
									className="left"
									name="nom"
									ref={this.refNom}
									onKeyUp={(e) => onEnter(e, this.search)}
								/>
							</div>
							<div className="lab-in full">
								<label htmlFor="marque">Marque</label>
								<input
									type="text"
									className="left"
									name="marque"
									ref={this.refMarque}
									onKeyUp={(e) => onEnter(e, this.search)}
								/>
							</div>
							<div className="lab-in full">
								<label htmlFor="plaques">Plaques</label>
								<input
									type="text"
									className="left"
									name="plaques"
									ref={this.refPlaques}
									onKeyUp={(e) => onEnter(e, this.search)}
									style={{ textTransform: "uppercase" }}
								/>
							</div>
							{fetchEmployes.loading ? (
								<div className="full lab-in row flex-center sync">
									<FontAwesomeIcon icon={faSync} spin />
								</div>
							) : (
								<div className="lab-in full">
									<label htmlFor="employe">Mécanicien</label>
									<select
										name="employe"
										ref={this.refDepanneur}
										onKeyUp={(e) => onEnter(e, this.search)}
									>
										<option value={0}>-</option>
										{employes.map((dep) => (
											<option
												key={dep.id + dep.nom}
												value={dep.id}
											>
												{dep.nom}
											</option>
										))}
									</select>
								</div>
							)}
							<div className="lab-in full">
								<label htmlFor="etat">Etat</label>
								<select
									name="etat"
									ref={this.refEtat}
									onKeyUp={(e) => onEnter(e, this.search)}
								>
									<option value={-2}>-</option>
									{ATELIER_ETATS_CHOICES.map(
										(etat, index) => (
											<option
												key={`etat_${index}`}
												value={etat[0]}
											>
												{etat[1]}
											</option>
										),
									)}
								</select>
							</div>
							<div className="full row sb">
								<div className="lab-in third px-0">
									<label htmlFor="dateT">Date</label>
									<select name="dateT" ref={this.refDateT}>
										<option value={0}>Création</option>
										<option value={1}>
											Travaux terminés
										</option>
										<option value={2}>Facturation</option>
									</select>
								</div>
								<div className="lab-in third px-0">
									<label htmlFor="dateS">Du</label>
									<input
										type="text"
										name="dateS"
										ref={this.refDateS}
										onKeyDown={(e) =>
											Addons.typeDateSearch(
												e,
												this.refDateE,
												null,
											)
										}
									/>
								</div>
								<div className="lab-in third px-0">
									<label htmlFor="dateE">Au</label>
									<input
										type="text"
										name="dateE"
										ref={this.refDateE}
										onKeyDown={(e) =>
											Addons.typeDateSearch(
												e,
												null,
												this.search,
											)
										}
									/>
								</div>
							</div>
						</div>

						<div className="form-small form-dep form-full row flex-center">
							<div className="lab-in small">
								<label htmlFor="svp" className="center">
									SVP
								</label>
								<input
									className={"big hover"}
									type="checkbox"
									name="svp"
									checked={this.state.isSVP}
									onChange={() =>
										this.setState({
											isSVP: !this.state.isSVP,
										})
									}
									ref={this.refSVP}
								/>
							</div>
							{this.props.navInfo.login.groups.includes(
								"boss",
							) ? (
								<div className="lab-in small">
									<label htmlFor="boss" className="center">
										Boss
									</label>
									<input
										className="m-auto big hover"
										type="checkbox"
										name="boss"
										checked={this.state.boss}
										onChange={() =>
											this.setState({
												boss: !this.state.boss,
											})
										}
										ref={this.refBoss}
									/>
								</div>
							) : null}
						</div>
						<div className="row flex-center full">
							<button
								type="button"
								className="norm-btn2 mx-20"
								onClick={() => this.search()}
							>
								{!atelierSearchInfo.loading ? (
									"Rechercher"
								) : (
									<FontAwesomeIcon icon={faSync} spin />
								)}
							</button>
							<button
								type="button"
								className="norm-btn2 mx-20"
								onClick={() => this.reset()}
							>
								Réinitialiser
							</button>
						</div>
					</form>
					{atelierSearchInfo.atelierFiches.length === 0 &&
					!atelierSearchInfo.hideResult ? (
						<h2 className="info">Aucune fiche trouvée</h2>
					) : null}
					{atelierSearchInfo.loading ? null : (
						<div className="col full flex-center">
							<div
								className={`table-container anim-hide ${atelierSearchInfo.atelierFiches.length > 0 && !atelierSearchInfo.hideResult ? "" : " hidden"}`}
							>
								<table>
									<thead>
										<tr>
											<th>N°</th>
											<th>
												Date{" "}
												<button
													type="button"
													onClick={() =>
														this.sortByDate()
													}
													style={
														this.state.sortByDate
															? {
																	transform:
																		"rotate(180deg)",
																}
															: {}
													}
												>
													<FontAwesomeIcon
														icon={faChevronDown}
													/>
												</button>
											</th>
											{!this.state.isSVP && (
												<th>
													Nom{" "}
													<button
														type="button"
														onClick={() =>
															this.sortByNom()
														}
														style={
															this.state.sortByNom
																? {
																		transform:
																			"rotate(180deg)",
																	}
																: {}
														}
													>
														<FontAwesomeIcon
															icon={faChevronDown}
														/>
													</button>
												</th>
											)}
											<th>Marque</th>
											{this.state.isSVP && (
												<th>Modèle</th>
											)}
											<th>Plaques</th>
											<th>
												Etat{" "}
												<button
													type="button"
													onClick={() =>
														this.sortByEtat()
													}
													style={
														this.state.sortByEtat
															? {
																	transform:
																		"rotate(180deg)",
																}
															: {}
													}
												>
													<FontAwesomeIcon
														icon={faChevronDown}
													/>
												</button>
											</th>
											<th>
												Mécanicien{" "}
												<button
													type="button"
													onClick={() =>
														this.sortByEmploye()
													}
													style={
														this.state.sortByEmploye
															? {
																	transform:
																		"rotate(180deg)",
																}
															: {}
													}
												>
													<FontAwesomeIcon
														icon={faChevronDown}
													/>
												</button>
											</th>
											<th>
												Montant{" "}
												<button
													type="button"
													onClick={() =>
														this.sortByTotal()
													}
													style={
														this.state.sortByTotal
															? {
																	transform:
																		"rotate(180deg)",
																}
															: {}
													}
												>
													<FontAwesomeIcon
														icon={faChevronDown}
													/>
												</button>
											</th>
											<th>Outil</th>
										</tr>
									</thead>
									<tbody>
										{atelierSearchInfo.atelierFiches.map(
											(atelier, index) => (
												<tr
													key={atelier.id}
													className={`${this.props.atelierId === atelier.id ? "" : this.state.selectedRow === index ? "selected" : atelier.is_client_incomplet ? "warning" : ""}`}
													onClick={() =>
														this.clickRow(index)
													}
													onDoubleClick={() =>
														this.doubleClickRow(
															atelier.id,
														)
													}
												>
													<td
														className={
															atelier.allALPaid ||
															this.state.isSVP
																? ""
																: "cell-show"
														}
													>
														{index + 1}
													</td>
													<td>{atelier.date}</td>
													{!this.state.isSVP && (
														<td>{atelier.nom}</td>
													)}
													<td>{atelier.marque}</td>
													{this.state.isSVP && (
														<td>
															{atelier.modele}
														</td>
													)}
													<td>{atelier.plaques}</td>
													<td>{atelier.etat}</td>
													<td>{atelier.employe}</td>
													<td>
														{this.getTotal(atelier)}
													</td>
													<td>
														{atelier.dep > 0 ? (
															<button
																type="button"
																onClick={() =>
																	this.setState(
																		{
																			redirectDep: true,
																			redirectDepId:
																				atelier.dep,
																		},
																	)
																}
															>
																<FontAwesomeIcon
																	icon={
																		faTruckPickup
																	}
																/>
															</button>
														) : null}
														{atelier.location >
														0 ? (
															<button
																type="button"
																onClick={() =>
																	this.setState(
																		{
																			redirectLocation: true,
																			redirectLocationId:
																				atelier.location,
																		},
																	)
																}
															>
																<FontAwesomeIcon
																	icon={faCar}
																/>
															</button>
														) : null}
														{this.props.navInfo.login.groups.includes(
															"boss",
														) ? (
															<button
																type="button"
																onClick={() =>
																	this.openModalDelete(
																		atelier.id,
																		`Atelier du ${atelier.date}`,
																	)
																}
															>
																<FontAwesomeIcon
																	icon={
																		faTrash
																	}
																/>
															</button>
														) : null}
													</td>
												</tr>
											),
										)}
									</tbody>
								</table>
							</div>
							<div className="row half flex-center">
								<button
									type="button"
									onClick={() =>
										atelierTable(
											atelierSearchInfo.atelierFiches,
										)
									}
									className={`norm-btn2 mx-20 anim-hide ${atelierSearchInfo.atelierFiches.length > 0 && !atelierSearchInfo.hideResult ? "" : " hidden"}`}
								>
									Imprimer
								</button>
								{this.props.navInfo.login.groups.includes(
									"boss",
								) && !this.state.isSVP ? (
									<>
										<button
											type="button"
											disabled={
												atelierSearchInfo.atelierFiches.filter(
													(ate) => !ate.allALPaid,
												).length > 0
											}
											onClick={() => this.openMarge()}
											className={`norm-btn2 mx-20 anim-hide ${atelierSearchInfo.atelierFiches.length > 0 && !atelierSearchInfo.hideResult ? "" : " hidden"}`}
										>
											Marge
										</button>
									</>
								) : null}
								{this.props.navInfo.login.groups.includes(
									"boss",
								) ? (
									<>
										<button
											type="button"
											onClick={() => this.openTotal()}
											className={`norm-btn2 mx-20 anim-hide ${atelierSearchInfo.atelierFiches.length > 0 && !atelierSearchInfo.hideResult ? "" : " hidden"}`}
										>
											Totaux
										</button>
									</>
								) : null}
								<button
									type="button"
									className={`norm-btn2 mx-20 anim-hide ${!atelierSearchInfo.hideResult ? "" : " hidden"}`}
									onClick={() => this.hideSearch()}
								>
									Retour
								</button>
							</div>
						</div>
					)}
				</div>
			</>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		atelierSearchInfo: state.atelierSearchInfo,
		employes: state.masterReducer.employes,
		appels: state.depInfo.appels,
		fetchEmployes: state.masterReducer.fetchEmployes,
		fetchAppels: state.depInfo.fetchAppels,
		user: state.navInfo.user,
		atelierId: state.atelierInfo.atelier.id,
		navInfo: state.navInfo,
	}
}

export default connect(mapStateToProps)(AtelierSearch)
